import React, { useState } from "react";
import "./Refresh_btn.css";

function Refresh_btn() {
  const [rotate, setRotate] = useState(false);

  const handleRefresh = () => {
    setRotate(true);

    // remove class after animation ends
    setTimeout(() => {
      setRotate(false);
    }, 600); // match CSS duration
  };

  return (
    <section className="Refresh_btn_holder">
      <div className="refresh_img_holder" onClick={handleRefresh}>
        <img
          src="/assets/images/other/refresh.png"
          className={`refresh_img ${rotate ? "rotate" : ""}`}
          alt="refresh"
        />
      </div>
    </section>
  );
}

export default Refresh_btn;
